/*
auto-generated by: https://github.com/pmndrs/gltfjsx
*/
import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export default function Model(props) {
  const group = useRef();
  const { nodes, materials } = useGLTF("/modelli/polsino_2.glb");

  const { tessuto, bottoni, asole, opa, matBottone, club } = props;

  return (
    <group ref={group} {...props} dispose={null}>
      <group position={[-0.27, -0.32, -0.035]} rotation={[1.22, 0, 2.69]}>
        <mesh
          material={materials.Material5126}
          geometry={nodes.MatShape_12037_Node.geometry}
          scale={[0.5, 0.5, 0.5]}
        >
          <meshMatcapMaterial
            attach="material"
            matcap={matBottone}
            color={bottoni}
          />
        </mesh>
      </group>
      <group position={[0.27, -0.32, -0.034]} rotation={[1.19, -0.01, -2.68]}>
        <mesh
          material={materials.Material5126}
          geometry={nodes.MatShape_12046_Node.geometry}
          scale={[0.5, 0.5, 0.5]}
        >
          <meshMatcapMaterial
            attach="material"
            matcap={matBottone}
            color={bottoni}
          />
        </mesh>
      </group>
      <mesh
        material={materials["PT_FABRIC_FRONT_3211.005"]}
        geometry={nodes.MatShape_12713_Node.geometry}

        position={[-0.269, -0.32, -0.0345]}
        rotation={[-0.07, 0.41, -0.3]}
      >
        <meshStandardMaterial color={asole} transparent={true} opacity={opa} />
      </mesh>
      <mesh
        material={materials["FABRIC 1_FRONT_13545"]}
        geometry={nodes.Cuffs_Node.geometry}
      >
        <meshStandardMaterial
          map={!club ? tessuto : null}
          roughness={1}
          toneMapped={false}
        />
      </mesh>
      <mesh
        material={materials["FABRIC 1_FRONT_13545"]}
        geometry={nodes.Cuffs_1_Node.geometry}
      >
        <meshStandardMaterial
          map={!club ? tessuto : null}
          roughness={1}
          toneMapped={false}
        />
      </mesh>
      <mesh
        material={materials["PT_FABRIC_FRONT_3211.005"]}
        geometry={nodes.MatShape_12713_Node001.geometry}
        position={[0.271, -0.32, -0.0313]}
        
      >
        <meshStandardMaterial color={asole} transparent={true} opacity={opa} />
      </mesh>
    </group>
  );
}

useGLTF.preload("/modelli/polsino_2.glb");
